import React from 'react';
import { ProductInterface } from 'modules/product/interfaces/product.interface';
import { getProductStructuralData } from 'helpers/get-product-structural-data';

const ProductStructuralData: React.FC<{
    product: Pick<ProductInterface, 'id' | 'name' | 'partNo' | 'isbn' | 'url' | 'category'
        | 'photos' | 'producer' | 'ean' | 'description' | 'opinions' | 'offers' | 'minPrice' | 'maxPrice'>;
}> = ({ product }) => {
    if (!product) {
        return null;
    }

    const data = getProductStructuralData(product);

    if (!data.review && !data.offers && !data.aggregateRating) {
        return null;
    }

    return (
        <script
            dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
            type="application/ld+json"
        />
    );
};

export default ProductStructuralData;
